import {
  MessageSquare,
  TrendingUp,
  Brain,
  Heart,
  Clock,
  BarChart3,
  Target,
  BookOpen 
} from "lucide-react";
import { useTranslation } from "react-i18next";

const AIAnalysisNavigation = ({ activeSection, setActiveSection, report }) => {
   const { t } = useTranslation();
  const sections = [
    { id: "overview", label: t("aianlysis.overview"), icon: BarChart3, color: "blue" },
    { id: "performance", label: t("aianlysis.performance"), icon: TrendingUp, color: "green" },
    { id: "progress", label: t("aianlysis.progress"), icon: Target, color: "purple" },
    { id: "behavioral", label: t("aianlysis.behavioral"), icon: Clock, color: "orange" },
    { id: "emotional", label: t("aianlysis.emotional"), icon: Heart, color: "red" },
    { id: "feedback", label: t("aianlysis.feedback"), icon: MessageSquare, color: "indigo" },
    { id: "assignment", label: t("aianlysis.assignment"), icon: BookOpen, color: "cyan" },
  ];

  // Helper to get Tailwind color classes
  const getColorClasses = (color, isActive) => {
    const map = {
      blue: { bg: "bg-blue-100", text: "text-blue-700", border: "border-blue-300" },
      green: { bg: "bg-green-100", text: "text-green-700", border: "border-green-300" },
      purple: { bg: "bg-purple-100", text: "text-purple-700", border: "border-purple-300" },
      orange: { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-300" },
      red: { bg: "bg-red-100", text: "text-red-700", border: "border-red-300" },
      indigo: { bg: "bg-indigo-100", text: "text-indigo-700", border: "border-indigo-300" },
      cyan: { bg: "bg-cyan-100", text: "text-cyan-700", border: "border-cyan-300" },

    };
    return isActive
      ? `${map[color].bg} ${map[color].text} border-2 ${map[color].border}`
      : "bg-slate-100 text-slate-600 hover:bg-slate-200 border-2 border-transparent";
  };

  // Format analysis date safely
  const formattedDate = report?.analysis_date
    ? new Date(report.analysis_date).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      })
    : null;

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold flex items-center space-x-2">
          <Brain className="w-6 h-6 text-blue-600" />
          <span>{t("aianlysis.aiLearningAnalytics")}</span>
        </h2>
        {formattedDate && (
          <p className="text-sm text-gray-500">{t("aianlysis.lastUpdated")} {formattedDate}</p>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => setActiveSection(section.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${getColorClasses(
              section.color,
              activeSection === section.id
            )}`}
          >
            <section.icon className="w-4 h-4" />
            <span>{section.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AIAnalysisNavigation;
